import * as Yup from 'yup'

import { hasAtLeastOneScope } from './overrideScope'

const SCOPE_REQUIRED_MESSAGE =
  'Select at least one scope (Entity, Country, PSP/Method, Client Type or Wallet Type).'

const scopeShape = {
  tickmillCompanyId: Yup.number().nullable(),
  countryId: Yup.string().nullable(),
  paymentProviderId: Yup.string().nullable(),
  clientTypeId: Yup.number().nullable(),
  walletTypeId: Yup.number().nullable(),
}

export const disableOverrideValidationSchema = Yup.object({
  ...scopeShape,
  enabled: Yup.boolean().required(),
}).test('at-least-one-scope', SCOPE_REQUIRED_MESSAGE, (values) =>
  hasAtLeastOneScope({
    tickmillCompanyId: values.tickmillCompanyId ?? null,
    countryId: values.countryId ?? null,
    paymentProviderId: values.paymentProviderId ?? null,
    clientTypeId: values.clientTypeId ?? null,
    walletTypeId: values.walletTypeId ?? null,
  })
)

export const amountOverrideValidationSchema = Yup.object({
  ...scopeShape,
  enabled: Yup.boolean().required(),
  limits: Yup.array()
    .of(
      Yup.object({
        currencyId: Yup.string().required('Currency is required'),
        maxAmount: Yup.number().moreThan(0, 'Must be greater than 0').required('Required'),
      })
    )
    .min(1, 'Add at least one currency limit'),
}).test('at-least-one-scope', SCOPE_REQUIRED_MESSAGE, (values) =>
  hasAtLeastOneScope({
    tickmillCompanyId: values.tickmillCompanyId ?? null,
    countryId: values.countryId ?? null,
    paymentProviderId: values.paymentProviderId ?? null,
    clientTypeId: values.clientTypeId ?? null,
    walletTypeId: values.walletTypeId ?? null,
  })
)
